import { getCities, getCounties, getCustomAreas, getStates } from '../../components/lookups/lookups.api';

export const LOOKUP_KEYS = {
  States: 'states',
  Counties: 'counties',
  CustomAreas: 'custom-areas',
  Cities: 'cities',
};

export const LOOKUP_APIS = {
  [LOOKUP_KEYS.States]: getStates,
  [LOOKUP_KEYS.Cities]: getCities,
  [LOOKUP_KEYS.Counties]: getCounties,
  [LOOKUP_KEYS.CustomAreas]: getCustomAreas,
} as const;
